import './FindId.scss';
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import TermsAgreementInfo from './TermsAgreementInfo'; // 이용약관 컴포넌트 임포트
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';
import CertPhone from './CertPhone';

function FindId() {
  const svrUrl = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();

  const [userInput, setUserInput] = useState({
    acaCode: fnc.getCookie_public('certCode_find'),
    username: '',
    phone: '',
  });


  const [isModal, setIsModal] = useState(false);
  const [isCertOk, setIsCertOk] = useState(false);
  const [resultId, setResultId] = useState('');
  const [isShowInfo, setIsShowInfo] = useState(false);
  const [findId, setFindId] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInput({
      ...userInput,
      [name]: value,
    });
  };



  const validateForm = () => {

    if (!userInput.acaCode.trim()) {
      alert('인증코드를 입력해 주세요.');
      return false;
    }

    if (!userInput.username.trim()) {
      alert('이름을 입력해 주세요.');
      return false;
    }

    const phonePattern = /^[0-9]{10,11}$/;
    if (!userInput.phone) {
      alert( '휴대전화 번호를 입력해 주세요.');
      return false;
    } else if (!phonePattern.test(userInput.phone)) {
      alert('유효한 휴대전화 번호를 입력해 주세요.');
      return false;
    }

    return true;
  };


  function onClose() {
    navigate(-1);
  }

  useEffect(() => {

    if (isCertOk) {
      setIsCertOk(false);
      onSendMsg((res) => {
        if (res.success === true) {
          alert('아이디가 전송되었습니다.');
        } else {
          alert('아이디가 전송에 실패했습니다.');
        }   
      });

    }
  }, [isCertOk]);



  function onConfirm() {

    if (!validateForm()) return;
    setIsShowInfo(false);

    fncInfoAca(userInput.acaCode, (acaDbName) => {
    
      if (acaDbName) {
        fncExistUser(acaDbName, (res) => {
          if (Array.isArray(res) && res.length > 0) {
            const id =  res[0].id;
            const sDate =  res[0].sDate;
            // fnc.setCookie('id', id);//이건 저장하면 안 돼 (로그인 시 떠)
            fnc.setCookie_public('acaCode_find', res[0].stCode);//문자전송 시 필요
            fnc.setCookie_public('stCode_find', res[0].stCode);//문자전송 시 필요
            fnc.setCookie_public('userName_find', res[0].name);//문자전송 시 필요
            fnc.setCookie_public('hp_find', res[0].hp);//문자전송 시 필요

            const maskedId = id.slice(0, -3) + "***";
            const resultId = `${maskedId} (${sDate} 가입)`;
            setFindId(id);//전체 아이디 찾기용
            setResultId(resultId);
            setIsShowInfo(true);
          } else {
            setResultId('');
        
            alert('정보가 올바르지 않습니다.');
          }
        });
      } else {
        alert('인증코드가 올바르지 않습니다.');
      }

    })
  }

  function fncInfoAca(certCode, callback) {
    fnc.sendAxios('/infoAca', { certCode }, (res) => {
      if (res && Array.isArray(res) && res[0] && res[0].acaDbName) {  
          const acaDbName = res[0].acaDbName;
          callback(acaDbName); 
      } else {
          callback(false);  
      }
    });
  }

  function fncExistUser(acaDbName, callback) {
    fnc.sendAxios('/kuesbFindPwIdRoutes/exist_userName_phone', {
      userName: userInput.username,
      hp: userInput.phone, 
      acaDbName,
    }, (res) => {

      // console.log(res, '>>>>>>>>>>>>>>>>> res');
      if (Array.isArray(res)) {
          // 학생정보;
          callback(res);
        } else {
          // alert('정보가 올바르지 않습니다.');
          callback(false);
      }

    });
  }

  
  function onSendMsg(callback) {

    const sendPhoneNumber = process.env.REACT_APP_sendPhone;
    const billId = process.env.REACT_APP_BILL_ID;//'kuesb'
    const senderPhone = sendPhoneNumber; //'01093871431';
    const originalSenderPhone = senderPhone;
    
    const acaCode = fnc.getCookie_public('acaCode_find');
    const stCode = fnc.getCookie_public('stCode_find');
    const stName = fnc.getCookie_public('stName_find');
    const hp = fnc.getCookie_public('hp_find');
    const gangsaName = '';
    const sendDate = fnc.getNow();

    const category = '아이디찾기';
    const recivePhone = hp;//'01088906672';
    const msgContent = `${findId} 입니다.`;
    
    fnc.sendAxios('/kuesbSmsRoutes/insert/sms', { 
      recivePhone, // 받는사람 (수신자 전화번호)
      senderPhone, // 보낸사람 (발신자 전화번호)
      sendDate,
      msgContent, //전송 메시지
      originalSenderPhone, //보낸사람 (원래 발신자)
      billId, 
      acaCode, 
      stCode,
      stName, //성명
      gangsaName, //담임
      category, //항목
    }, (res) => {
      callback(res);
      // console.log(res, Array.isArray(res) ? 'sms' : "kuesbSmsRoutes/insert/sms");
    });
  
  }
  //===========================================================================
  return (
    <S.Section2>
    <div className='FindId'>
    <div className='wrap-main'>
      
      <section className='section-singnup'>
          <p className='title'>아이디 찾기</p>

          <article className='article-input'>   

             <div>
                <label htmlFor="userid">*인증코드</label>
                <input
                  type="text"
                  id="acaCode"
                  name="acaCode"
                  value={userInput.acaCode}
                  onChange={handleChange}
                  required
                  placeholder='인증코드를 입력해 주세요.'
                />
              </div>

           
              <div>
                <label htmlFor="username">*이름</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={userInput.username}
                  onChange={handleChange}
                  required
                  placeholder='이름을 입력해 주세요.'
                />
              </div>

              <div>
                <label htmlFor="phone">*휴대전화</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={userInput.phone}
                  onChange={handleChange}
                  required
                  placeholder='- 없이 입력해주세요.'
                />
              </div>
    
          </article>

         {isShowInfo && <article className='article-resultInfo'>
            <p className='lblResultInfo'>*입력하신 정보와 일치하는 아이디는 아래와 같습니다.</p>
            <p className='lblResultInfo-id'>{resultId}</p>

            <article className='article-menu-idInfo'>
              <Button className='btnClose h-btn-gray' onClick={() => navigate('/')}>로그인</Button>
              <Button className='btnSave h-btn-green' onClick={() => setIsModal(true)} >아이디 전체 찾기</Button>
            </article>

          </article> }


          <article className='article-termsAgreementInfo'>
            <TermsAgreementInfo />
          </article>

        
          {!isShowInfo && <article className='article-menu'>
            <Button className='btnClose h-btn-gray' onClick={onClose}>취소</Button>
            <Button className='btnSave h-btn-red' onClick={onConfirm} >확인</Button>
          </article> }

         
  
      </section>

      {isModal && <div className='box_modal'>
              <CertPhone setIsModal={setIsModal} title={'아이디 찾기'} setIsCertOk={setIsCertOk} />
      </div> }    

   
      
    
    
    </div>
    </div>
    </S.Section2>
  );
}

export default FindId;
